import ToolTip from 'Components/ToolTip';
import apiGlobal from 'global/api.global';
import { RootState } from 'index';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Row, Col, Label } from 'reactstrap'
import STSAdjustmentPopup from './STSAdjustmentPopup';
import { Roles } from 'shared/constants';
import { hasRole } from 'utils/auth/authUtils';
import STSAjustmentTableHeadComponent from './STSAjustmentTableHeadComponent';
import AdjustmentPaginationComponent from 'Adjustments/AdjustmentPaginationComponent';
import ValidateIcon from '../../Media/VLD1.png'
import Message from 'Components/Message';
import { dateTimeFormat } from 'GenericForms/Helper';

const PendingSTSAdjustment = ({ active }: any) => {
    /** State variables */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [tableDetails, setTableDetails] = useState({
        size: 5,
        index: 0,
        stsAdjustment: []
    })
    const [count, setCount] = useState(0);
    const [adjustmentPopup, setAdjustmentPopup] = useState(false);
    const [eventState, setEventState] = useState<any>({});
    const [hoverId, setHoverId] = useState<string | null>(null);
    /** State variables end */

    /** Load STS operations pending for approval of the selected vessel */
    const loadData = async () => {
        await apiGlobal.get(`sts_operation_detail/get_sts_operation_details_by_vessel/?vessel_id=${VesselID}`).then(response => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                stsAdjustment: response.data.filter((item: any) => item.user_approved === false)
            }))
            setCount(count => count + 1);
        }).catch(() => {
            setTableDetails(prevDetails => ({
                ...prevDetails,
                stsAdjustment: []
            }))
        })
    };

    /** useEffect start */
    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [VesselID, active])
    /** useEffect end */

    /** Open-close modal */
    function tog_backdrop() {
        setAdjustmentPopup(!adjustmentPopup);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <div className="table-responsive">
                        <table className="table mb-0" key={count}>
                            <STSAjustmentTableHeadComponent />
                            <tbody>
                                {tableDetails?.stsAdjustment?.length > 0 ?
                                    (tableDetails && tableDetails?.stsAdjustment?.slice(tableDetails?.index * tableDetails?.size,
                                        tableDetails?.index * tableDetails?.size + tableDetails?.size)?.map((sts: any, index: number) => {
                                            return (
                                                <tr>
                                                    <td className='p-2 align-middle text-center'>{index + 1}</td>
                                                    <td className='p-2 align-middle'>
                                                        {sts?.sts_end_time === null ?
                                                            <>Currently in progress</> :
                                                            <Label className='mb-0'>
                                                                <b>{dateTimeFormat(sts?.sts_start_time, false, false, true)}</b> to&nbsp;
                                                                <b>{dateTimeFormat(sts?.sts_end_time, false, false, true)}</b>
                                                            </Label>
                                                        }
                                                    </td>
                                                    <td className='p-2 align-middle'>
                                                        <Label className='mb-0'>STS {sts?.sts_operation_name}</Label>
                                                    </td>
                                                    {!(hasRole(Roles.CHIEFENGINEER)) &&
                                                        <td className='nopadtop d-flex flex-warp p-2 gap-2 justify-content-center'>
                                                            <img
                                                                src={ValidateIcon}
                                                                alt="Validate Icon"
                                                                id={`sts_validate${index}`}
                                                                className='text-centre pointer'
                                                                height="30"
                                                                onMouseEnter={() => setHoverId(`sts_validate${index}`)}
                                                                onMouseLeave={() => setHoverId(null)}
                                                                onClick={() => {
                                                                    setAdjustmentPopup(true);
                                                                    setEventState(sts);
                                                                    setHoverId(null);
                                                                }}
                                                            />
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        }
                                        )) :
                                    <tr className='text-center'>
                                        <td colSpan={4}>
                                            <Message message='No STS Adjustments are available for this vessel.' type='danger' width='500px' />
                                        </td>
                                    </tr>
                                }
                                {hoverId !== null &&
                                    <ToolTip
                                        target={hoverId}
                                        message={`Validate STS Adjustment`}
                                        isOpen={hoverId !== null}
                                    />
                                }
                                {adjustmentPopup === true &&
                                    <STSAdjustmentPopup
                                        state={adjustmentPopup}
                                        setState={setAdjustmentPopup}
                                        toggle={tog_backdrop}
                                        event={eventState}
                                        target={`popup${eventState?.id}`}
                                    />
                                }
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
            {
                tableDetails?.stsAdjustment?.length > tableDetails?.size &&
                <AdjustmentPaginationComponent
                    count={count}
                    setCount={setCount}
                    tableDetails={tableDetails}
                    setTableDetails={setTableDetails}
                />
            }
        </React.Fragment >
    )
}

export default PendingSTSAdjustment